import React from 'react';

const DuoPeriodPicker = ({ options, selectedOption, onSelect }) => {
  return (
    <div className="duo-period-scroll" role="tablist" aria-label="Période">
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          role="tab"
          aria-selected={selectedOption.value === option.value}
          className={`duo-period-pill ${selectedOption.value === option.value ? 'is-active' : ''}`}
          onClick={() => onSelect(option)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default DuoPeriodPicker;
